import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, Modal, useToast } from '@morressier/alembic';
import { useResubmitSubmission } from 'src/api/commands';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateLeft } from '@fortawesome/pro-light-svg-icons';
import { IDecisionModalProps } from './decisionModalHelper';

type Props = IDecisionModalProps & { isFileUpdated: boolean };

export const ResubmitModal = ({
  onClose,
  submissionId,
  organizationId,
  submissionContextId,
  isFileUpdated
}: Props) => {
  const toast = useToast();
  const navigate = useNavigate();
  const { refetchSubmission } = useSubmissionData();
  const mutation = useResubmitSubmission(
    submissionId,
    submissionContextId,
    refetchSubmission,
    organizationId
  );

  const confirmResubmission = async () => {
    const response = await mutation.mutateAsync(isFileUpdated);

    if (!response.isSuccess) {
      toast({
        variant: 'error',
        title: 'Error resubmitting submission',
        description: `An error occurred: ${response.message}`,
        isClosable: true
      });
      return;
    }

    onClose();
    toast({
      variant: 'success',
      title: 'Submission Resubmitted',
      description: 'The editors will review your updated submission.',
      isClosable: true
    });
    navigate('?submissionType=my-submissions-active');
  };

  return (
    <Modal isOpen onClose={onClose} width="720px">
      <Flex padding={8} gap={4} flexDirection="column">
        <Box>
          <FontAwesomeIcon fontSize={32} icon={faArrowRotateLeft} />
        </Box>
        <Text textStyle="headingGroup">Submit Submission?</Text>
        <Text>
          By proceeding, you confirm that:
          <Box padding={2}>
            <ul>
              <li>
                You’ve reviewed and edited the Submission’s core details,
                preferences, and Author information;
              </li>
              <li>
                This updated version will be sent to Editors for re-assessment.
              </li>
            </ul>
          </Box>
        </Text>

        <Flex gap={2} justifyContent="flex-end">
          <Button
            onClick={onClose}
            variant="secondary"
            isDisabled={mutation.isLoading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            isLoading={mutation.isLoading}
            onClick={confirmResubmission}
          >
            Submit Submission
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
